import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/marketing/kit";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

function Node({ node }) {
  if (typeof node === "string") return <p>{node}</p>;
  if (node.sub) return <h3>{node.sub}</h3>;
  if (node.list) return <ul>{node.list.map((li, i) => <li key={i}>{li}</li>)}</ul>;
  return null;
}

export function LegalDoc({ eyebrow, title, updated, intro, sections, testid, children }) {
  const [active, setActive] = useState(sections[0]?.heading || "");
  useEffect(() => {
    const ids = sections.map((s) => slug(s.heading));
    const onScroll = () => {
      let cur = ids[0];
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 140) cur = id;
      }
      setActive(cur);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [sections]);

  return (
    <main className="mk-legal" data-testid={testid}>
      <section className="mk-sec mk-legal-hero"><div className="mk-wrap">
        <Reveal><span className="mk-pill"><ShieldCheck size={14} /> {eyebrow}</span></Reveal>
        <Reveal delay={0.08}><h1 className="mk-h2" data-testid="legal-title">{title}</h1></Reveal>
        <Reveal delay={0.16}><p className="mk-lead" data-testid="legal-updated">Last updated: {updated}</p></Reveal>
        {intro && <Reveal delay={0.22}><p className="mk-legal-intro">{intro}</p></Reveal>}
        <Reveal delay={0.28}><p className="mk-legal-note" data-testid="legal-disclaimer">This document is provided for transparency and does not constitute legal advice. We recommend reviewing it with your own legal counsel before relying on it.</p></Reveal>
      </div></section>

      <section className="mk-sec mk-legal-body"><div className="mk-wrap mk-legal-grid">
        <aside className="mk-legal-toc" data-testid="legal-toc">
          <b>On this page</b>
          <nav>
            {sections.map((s) => (
              <a key={s.heading} href={`#${slug(s.heading)}`} className={active === slug(s.heading) ? "active" : ""} data-testid={`legal-toc-${slug(s.heading)}`}>{s.heading}</a>
            ))}
          </nav>
        </aside>
        <article className="mk-legal-content">
          {sections.map((s, i) => (
            <section key={s.heading} id={slug(s.heading)} className="mk-legal-section" data-testid={`legal-section-${slug(s.heading)}`}>
              <h2><span className="mk-legal-num">{String(i + 1).padStart(2, "0")}</span>{s.heading}</h2>
              {s.body.map((n, j) => <Node key={j} node={n} />)}
            </section>
          ))}
          {children}
          <div className="mk-legal-cta">
            <p>Questions about this policy? We're happy to help.</p>
            <Link to="/contact" className="mk-btn primary" data-testid="legal-contact-cta">Contact us <ArrowRight size={16} /></Link>
          </div>
        </article>
      </div></section>
    </main>
  );
}
